export default class ServiceService {
	constructor(apiService) {
		this.apiService = apiService
	}


	getEntity(id, params) {
		return this.apiService.callGet('serviceWeightCategories/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('serviceWeightCategories', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('serviceWeightCategories/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('serviceWeightCategories/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('serviceWeightCategories', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ServiceWeightCategoryService.js